import type { Account } from '@/types/serializers'
import AccountLayout from './_layout/AccountLayout.tsx'
import DetailsTab from './_tabs/DetailsTab'

interface DetailsProps {
    account: Account
}

export default function AccountDetails({account}: DetailsProps) {
    return (
        <AccountLayout account={account} activeTab="details">
            <DetailsTab valueDiscoveryFrameworks={account.valueDiscoveryFramework}/>
        </AccountLayout>
    )
}